export default __webpack_public_path__ + "static/media/great-minds-think-alike.1d1ea49d.gif";